import queryString from "query-string";
import { parametersToQuery } from "../../../search/api";

export function updateSearchParams(params) {
	const query = parametersToQuery(params);
	const newUrl =
		window.location.protocol +
		"//" +
		window.location.host +
		window.location.pathname +
		"?" +
		query;
	window.history.pushState({ path: newUrl }, "", newUrl);
}

export function clearSearchParams() {
	const url = new URL(window.location.href);

	if (url.search) {
		url.search = "";
		window.history.replaceState(null, null, url);
	}
}

const SEARCH_PARAMS_STORAGE_KEY_PREFIX = "admin-search-params:";

function getSearchParamsStorageKey() {
	return SEARCH_PARAMS_STORAGE_KEY_PREFIX + location.pathname;
}

export function getInitialParams(saveFormToLocalStorage) {
	const queryParams = queryString.parse(location.search, {
		arrayFormat: "bracket",
	});

	if (!saveFormToLocalStorage || Object.keys(queryParams).length > 0) {
		return queryParams;
	}

	const storedParams = localStorage.getItem(getSearchParamsStorageKey());
	return storedParams ? JSON.parse(storedParams) : {};
}

export function saveParams(params) {
	localStorage.setItem(getSearchParamsStorageKey(), JSON.stringify(params));
}

export function clearStoredParams() {
	localStorage.removeItem(getSearchParamsStorageKey());
}

export function trimParams(params) {
	Object.keys(params).forEach(
		(k) =>
			(params[k] =
				typeof params[k] == "string" ? params[k].trim() : params[k]),
	);
	return params;
}
